<template>
  <div class="window service-window add-dop-service-window" v-show="isVisible">
    <span class="close" title="Закрыть" @click="$emit('close-window', false)"><img src="../image/cancel.svg"></span>
    <div class="window-title">{{ isNew ? 'Добавить' : 'Редактировать' }} дополнительную услугу</div>
    <div class="form">
      <div class="title">Услуга:</div>
      <div class="service-main-info">
        <div class="visibility">
          <fieldset class="service">
            <select v-model="additionalService.category">
              <option v-for="category in additionalCategories" :value="category" :disabled="!category">
                {{ category ? category.name : '-- Выбрать --' }}
              </option>
            </select>
          </fieldset>
          <fieldset class="quantity">
            <span>x</span>
            <input type="number" v-model="count" placeholder="1" v-show="!serviceIsPacking" :disabled="serviceIsPacking" @input="inputCount">
            <input type="number" v-model="additionalService.itemCount" placeholder="1" v-show="serviceIsPacking" :disabled="!serviceIsPacking" @input="inputCount">
            <span>шт.</span>
          </fieldset>
        </div>
      </div>
      <div class="buttons">
        <button type="button" class="save-button" @click="saveChanges">Сохранить</button>
      </div>
    </div>
  </div>
</template>
<script>
  import utils from '@/utils'

  const emptyAdditionalService = {
    type: 'OrderToAdditional',
    pathToClass: 'ru.itbrick.shustrikoffcrm.beans.OrderToAdditional',
    category: null,
    itemCount: 1
  };

  export default {
    name: 'AdditionalService',
    props: ['isVisible', 'index', 'isNew', 'orderDateTime'],

    data() {
      return {
        additionalService: Object.assign({}, emptyAdditionalService),
        count: 1,
      }
    },

    computed: {
      // Услуга является "Упаковкой"
      serviceIsPacking() {
        return this.additionalService.category && !!this.additionalService.category.packing;
      },

      additionalCategories() {
        let additionalCategories = this.$store.getters.additionalCategories
            .filter(category => !category.shippingPacking);
        additionalCategories.unshift(null);

        return additionalCategories;
      }
    },

    watch: {
      isVisible(val) {
        if (val) {
          if (!this.isNew) {
            let additionalServices = this.$store.getters.groupedServices[this.index];
            this.additionalService = Object.assign({}, additionalServices[0]);
            this.count = additionalServices.length;
          } else {
            let additionalService = {};
            Object.assign(additionalService, emptyAdditionalService);
            Object.assign(additionalService, {
              category: this.additionalCategories[0],
              date: this.orderDateTime
            });
            this.additionalService = additionalService;
          }
        }
      }
    },

    methods: {
      inputCount () {
          if (this.count <= 0 && this.count.length > 0) { this.count = 1 }
          if (this.additionalService.itemCount <= 0 && this.additionalService.itemCount.length > 0) { this.additionalService.itemCount = 1 }
      },
      saveChanges() {
        this.isNew
            ? this.addNewService()
            : this.updateService();
        this.$emit('close-window', false)
      },

      updateService() {
        if (!!this.additionalService.category.packing)
          this.count = 1;

        // при коммите в store index из property является undefined
        let index = this.index;
        let count = this.count;
        let serviceData = {
          category: this.additionalService.category,
          itemCount: this.additionalService.category.packing ? this.additionalService.itemCount : 1
        };

        this.$store.commit('updateGroupedServiceByIndex', {
          index: index,
          count: count,
          serviceData: serviceData
        })
      },

      addNewService() {
        utils.spotRegionAndDistrictByAddresses(this.$store.getters.addresses, this.$store.getters.regions, this.$store.getters.districts)
            .then(regionDistrictData => {
              Object.assign(this.additionalService, regionDistrictData);

              if (!!this.additionalService.category.packing)
                this.count = 1;
              else
                this.additionalService.itemCount = 1;

              let groupedService = [];
              for (let i = 0; i < this.count; i++) {
                groupedService.push(Object.assign({}, this.additionalService))
              }

              this.$store.commit('addNewGroupedService', groupedService)
            })
      }
    }
  }
</script>
